import { gql, query } from "../../utils/client";
import { emitError } from "../../utils/events";
import { BpNetworkError } from "../../utils/network";

/**
 * Used in custom converters to append URL parameters.
 */
export function authHrefConverter(value: null | string) {
  if (!value) return value;
  const redirect = globalThis.location.href;
  const source = redirect.includes("/classroom/") ? "classroom" : "web";

  return `${value}?redirect=${redirect}&source=${source}`;
}

/**
 * Performs an autocomplete request to the Cludo API and
 * returns parsed results.
 */
export async function autocomplete(input: string): Promise<string[]> {
  try {
    const response = await query<{ autocomplete: string[] }>({
      query: gql`
        query Autocomplete($query: String!) {
          autocomplete(query: $query)
        }
      `,
      variables: {
        query: input,
      },
    });

    return response?.data?.autocomplete ?? [];
  } catch (error) {
    // Emit an error event. If the error is a
    // BpNetworkError, emit a detailed error event.
    // Otherwise, emit a generic error event.
    if (error instanceof BpNetworkError) {
      emitError({
        name: error.name,
        message: error.message,
        reason: error.reason,
        ...error.detail,
      });
    } else {
      emitError({ error });
    }

    // Return empty array to avoid blocking the UI
    return [];
  }
}
